

















import Vue from "vue";
import { SharedState } from "@/common/state";
import { computed } from "@vue/composition-api";
import { InformationTypeTree } from "@/common/models";
import { common_state } from "../data/common.state";
import { flat_by } from "@/fp";

export default Vue.extend({
  props: ["value"],
  setup(props, { emit }) {
    const { l0InfoTypes, get_raw_info_types_tree } = SharedState;

    const change_l0 = (l0_id: string) => {
      if (props.value !== l0_id) {
        emit("input", l0_id);
      }
    };

    const has_mappable_children = (l0_id: string, mappable_ids: Set<string>): boolean => {
      const all_descendants = flat_by<InformationTypeTree, "nested">(
        "nested",
        (l) => l
      )(get_raw_info_types_tree([l0_id, ""]));
      return all_descendants.some((d) => mappable_ids.has(d.id));
    };

    return {
      l0s: computed(() => {
        let base;
        if (SharedState.FeatureHelper.is_enabled("expose_other")) {
          // @ts-ignore
          base = l0InfoTypes.value.filter((d) => !d.is_restricted);
        } else {
          base = l0InfoTypes.value.filter(
            (d) =>
              // @ts-ignore
              d.id !== SharedState.default_label_id.value && !d.is_restricted
          );
        }
        const mappable_ids = common_state.state.mappable_label_ids;
        if (mappable_ids.size > 0) {
          base = base.filter((d) => has_mappable_children(d.id, mappable_ids));
        }
        return base;
      }),
      change_l0,
    };
  },
});
